import {
  faCheckSquare,
  faChevronDown,
  faEllipsisH,
  faRedoAlt,
  faSquare,
  faTimesCircle,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import arrayMove from 'array-move';
import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import { Popover, PopoverHeader, PopoverBody, Button, UncontrolledTooltip, Input } from 'reactstrap';
import Swal from 'sweetalert2';
import { useAuth0 } from '../../../../../auth0/reactAuth0Spa';
import { formatBearerToken, calculatePercentage, calculateWeight } from '../../../../../Common.functions';
import { DepartmentContext } from '../../../../../DepartmentWrapper';
import { deleteData } from '../../../../../Services/dataApi';
import FocusPalette from '../../../Coordinator/Schedule/FocusPalette';
import { popoverModifiers } from '../../../../../enums';
import './EvaluationQuestion.style.css';
import style from './EvaluationQuestions.style';
import { clone } from 'lodash';
const array = [1, 2, 3, 4];
const PRESCREEN_TYPE_COLOR = '#702F9E';
const EVALUATION_TYPE_COLOR = 'var(--rr-primary-text)';

const EvaluationQuestion = ({
  changeValue,
  changeSortOrder,
  DragHandle,
  getQuestions,
  groupIndex,
  isUpdating,
  labelClick,
  numOfQuestionsInWeight,
  pk_QuestionGroup,
  question,
  questionIndex,
  questions,
  questionWeights,
  questionWeightTypesById,
  season,
  selectedQuestion,
  setSelectedQuestionId,
  toggleDeleteQuestion,
  deleteNewQuestion,
  isCard,
}) => {
  const [sortValue, setSortValue] = useState(1);
  const [evalPercentage, setEvalPercentage] = useState('-');
  const [prePercentage, setPrePercentage] = useState('-');
  const [evalChecked, setEvalChecked] = useState(false);
  const [preChecked, setPreChecked] = useState(false);
  const [selectedFocuses, setSelectedFocuses] = useState([]);
  const [isRequired, setIsRequired] = useState(false);

  const {
    QuestionText,
    WeightQuestionType,
    uuid,
    EnablePrescreenForm,
    EnableEvaluationForm,
    EnableRequired,
    EvaluationQuestionSortOrder,
    isToDelete,
    pk_EvaluationQuestionWeight,
    pk_EvaluationQuestion,
  } = question;

  const resolvedWeightQuestionType = WeightQuestionType || questionWeightTypesById?.[pk_EvaluationQuestionWeight];

  // Alert functionality replaced with toast

  useEffect(() => {
    // TODO: REMOVE AFTE JEFF UPDATED GET for Questions. BASE ON QUESTION ITSELF, NOT ON Weight
    if (pk_EvaluationQuestionWeight && questionWeights) {
      const weightUsed = questionWeights.find(
        (item) => item.pk_EvaluationQuestionWeight === pk_EvaluationQuestionWeight,
      );

      if (weightUsed) {
        setIsRequired(weightUsed.EnableRequired);
      }
    }
  }, [pk_EvaluationQuestionWeight, questionWeights]);

  const [showFocusPopover, setShowFocusPopover] = useState(false);
  let typeTimeout = null;
  let lastTypeField = null;

  const AllowPrescreen = season && season.data ? season.data.AllowPrescreen : false;
  const { getTokenSilently, loginWithRedirect } = useAuth0();
  const dContext = useContext(DepartmentContext);

  useEffect(() => {
    if (question && numOfQuestionsInWeight && questionWeights) {
      const prescreenResult = calculateWeight(
        'prescreen',
        question,
        numOfQuestionsInWeight,
        questionWeights,
        question.pk_EvaluationQuestionWeight,
        2,
      );
      const evaluationResult = calculateWeight(
        'evaluation',
        question,
        numOfQuestionsInWeight,
        questionWeights,
        question.pk_EvaluationQuestionWeight,
        2,
      );
      setEvalPercentage(evaluationResult);
      setPrePercentage(prescreenResult);
    }
  }, [JSON.stringify(question), numOfQuestionsInWeight, questionWeights]);

  useEffect(() => {
    if (question) {
      // Remove Redundant=====//
      const newFocuses = [];

      if (question.Focuses) {
        question.Focuses.forEach((f) => {
          if (
            !newFocuses.find((nF) => {
              return nF.pk_Focus === f.pk_Focus;
            })
          ) {
            newFocuses.push(f);
          }
        });
      }
      //==================//
      setSelectedFocuses(newFocuses);
    }
  }, [question]);

  const onWeightChange = (e) => {
    const { value } = e.target;
    changeValue(groupIndex, questionIndex, 'category', value);
  };

  const renderFocusPopover = () => {
    return (
      <Popover
        flip={false}
        modifiers={popoverModifiers}
        popperClassName="evaluation_focus"
        isOpen={showFocusPopover} // Change with room id later
        target={`button_${pk_EvaluationQuestion}_focusButton`} // Change with room id later
        trigger="legacy"
        toggle={(e) => {
          setShowFocusPopover(!showFocusPopover);
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            Focus Categories
            <div>
              <div style={style.simpleRow}>
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  style={style.clickableIcon}
                  onClick={(e) => {
                    setShowFocusPopover(false);
                  }}
                />
              </div>
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <FocusPalette
            itemParentObject={question}
            allowEdit={false}
            allowCreateFocus={true}
            showIgnoreSwitch={false}
            reference={selectedFocuses}
            updateSelectedFocuses={(newFocuses) => {
              setSelectedFocuses(newFocuses);
              changeValue(groupIndex, questionIndex, 'Focuses', newFocuses, pk_QuestionGroup);
            }}
            returnEntireFocusObject={true}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const getFocusNames = () => {
    let focusNames = '';

    if (selectedFocuses.length > 0) {
      selectedFocuses.forEach((focus, i) => {
        if (i > 0) {
          focusNames += `, ${focus.Name || '(No Name)'}`;
        } else {
          focusNames += focus.Name || '(No Name)';
        }
      });
    } else {
      focusNames = 'No Limit';
    }

    return focusNames;
  };

  const deleteQuestion = () => {
    const { pk_EvaluationQuestion } = question;
    if (pk_EvaluationQuestion) {
      toggleDeleteQuestion(groupIndex, questionIndex);
    } else {
      deleteNewQuestion(groupIndex, questionIndex);
    }
  };

  let backgroundColor = 'var(--rr-surface)';

  if ((!AllowPrescreen && !EnableEvaluationForm) || (AllowPrescreen && !EnableEvaluationForm && !EnablePrescreenForm)) {
    backgroundColor = 'var(--rr-surface-inactive)';
  } else if (selectedQuestion) {
    backgroundColor = 'var(--rr-primary-soft)';
  }

  if (isToDelete) {
    backgroundColor = 'var(--rr-danger-soft)';
  }

  if (!pk_EvaluationQuestion) {
    backgroundColor = 'var(--rr-success-soft)';
  }

  if (isCard) {
    return (
      <div
        style={{
          backgroundColor: backgroundColor,
          border: '1px solid #ccc',
          borderRadius: 8,
          margin: '8px 0',
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
        onClick={() => {
          setSelectedQuestionId(pk_EvaluationQuestion || uuid);
        }}
      >
        {/* Required Status Banner */}
        <div
          style={{
            backgroundColor: '#888888',
            color: isRequired || EnableRequired ? 'white' : 'white',
            padding: '8px 12px',
            borderRadius: '8px 8px 0 0',
            fontWeight: 'bold',
            fontSize: '14px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 12,
          }}
        >
          <div>#{EvaluationQuestionSortOrder}</div>
          <div>Required: {isRequired || EnableRequired ? 'Yes' : 'No'}</div>
        </div>

        {/* Card Content */}
        <div
          style={{
            padding: 12,
            display: 'flex',
            flexDirection: 'row',
            gap: 12,
          }}
        >
          {/* Left Column - Delete Button and Sort Order */}
          <div
            style={{
              width: 180,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: 8,
            }}
          >
            <div>
              {isToDelete ? (
                <div style={{ fontWeight: 'bold', color: 'white' }}>DELETE</div>
              ) : (
                <div>
                  <label style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: 4, display: 'block' }}>
                    Sort Order
                  </label>
                  <Input
                    disabled={isUpdating}
                    type="select"
                    id={`sort_${pk_EvaluationQuestion}`}
                    key={`sort_${pk_EvaluationQuestion}`}
                    name={`sort_${pk_EvaluationQuestion}`}
                    value={EvaluationQuestionSortOrder}
                    onChange={(e) => {
                      changeSortOrder(groupIndex, questionIndex, parseInt(e.target.value));
                    }}
                  >
                    {questions && questions[groupIndex].questions ? (
                      questions[groupIndex].questions.map((item, count) => (
                        <option key={item.pk_EvaluationQuestion} value={count + 1}>
                          {count + 1}
                        </option>
                      ))
                    ) : (
                      <option value={null} disabled selected>
                        No Sort Order
                      </option>
                    )}
                  </Input>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
              <Button
                disabled={isUpdating}
                color={(pk_EvaluationQuestion && !isToDelete) || !pk_EvaluationQuestion ? 'danger' : 'secondary'}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!pk_EvaluationQuestion) {
                    Swal.fire({
                      title: 'Warning!',
                      text: `Are you sure you want to delete this question? This cannot be undone.`,
                      type: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: 'red',
                      confirmButtonText: `Delete`,
                    }).then((result) => {
                      if (result.value) {
                        deleteQuestion();
                      }
                    });
                  } else {
                    deleteQuestion();
                  }
                }}
              >
                <FontAwesomeIcon icon={pk_EvaluationQuestion && isToDelete ? faRedoAlt : faTrash} />
              </Button>
            </div>
          </div>

          {/* Right Column - Everything Else */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
            }}
          >
            {/* Question Text - Full Width */}
            <div>
              <label style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: 4, display: 'block' }}>
                Question Text
              </label>
              <Input
                disabled={isUpdating || isToDelete}
                type="textarea"
                style={{ width: '100%' }}
                rows="3"
                id={`name_${pk_EvaluationQuestion}_${JSON.stringify(question)}`}
                key={`name_${pk_EvaluationQuestion}`}
                defaultValue={`${QuestionText}`}
                onChange={(e) => {
                  const newValue = e.target.value;
                  if (typeTimeout) {
                    if (lastTypeField !== 'QuestionText') {
                      lastTypeField = 'QuestionText';
                      if (typeTimeout.trigger) {
                        typeTimeout.trigger();
                      }
                    }
                    clearTimeout(typeTimeout);
                  }
                  typeTimeout = setTimeout(() => {
                    changeValue(groupIndex, questionIndex, 'QuestionText', newValue, pk_QuestionGroup);
                    lastTypeField = null;
                  }, 300);
                }}
              />
            </div>

            {/* Focus Button - Full Width */}
            <div>
              <label style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: 4, display: 'block' }}>
                Focus Limit
              </label>
              <Button
                disabled={isUpdating || isToDelete}
                type="button"
                id={`button_${pk_EvaluationQuestion}_focusButton`}
                color="secondary"
                size="sm"
                style={{ width: '100%' }}
                onClick={() => {}}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ flex: 1, textAlign: 'left' }}>{getFocusNames()}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div>({selectedFocuses.length})</div>
                    <FontAwesomeIcon icon={faChevronDown} />
                  </div>
                </div>
              </Button>
              <UncontrolledTooltip target={`button_${pk_EvaluationQuestion}_focusButton`}>
                {getFocusNames()}
              </UncontrolledTooltip>
              {renderFocusPopover()}
            </div>

            {/* Other Controls - Flexible Row */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 12,
              }}
            >
              <div>
                {resolvedWeightQuestionType === 'scale' ? (
                  <Button
                    disabled={isUpdating || isToDelete}
                    color={question.EnableCustomScale ? 'success' : 'warning'}
                    onClick={(e) => {
                      e.preventDefault();
                      labelClick({ ...question, questionIndex, groupIndex });
                    }}
                  >
                    <FontAwesomeIcon icon={faEllipsisH} />
                  </Button>
                ) : null}
              </div>
              <div>
                <label style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: 4, display: 'block' }}>
                  Weight Category
                </label>
                <Input
                  disabled={isUpdating || isToDelete}
                  type="select"
                  name="weightCategorySelect"
                  style={{ width: '100%' }}
                  onChange={onWeightChange}
                  value={pk_EvaluationQuestionWeight}
                >
                  {questionWeights.map((item) => {
                    return (
                      <option
                        selected={item.pk_EvaluationQuestionWeight === pk_EvaluationQuestionWeight}
                        value={item.pk_EvaluationQuestionWeight}
                      >
                        {item.CategoryName}
                      </option>
                    );
                  })}
                </Input>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: 4, display: 'block' }}>
                  Evaluation Type & Effective Weight
                </label>
                {AllowPrescreen ? (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: 4,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: EnablePrescreenForm ? PRESCREEN_TYPE_COLOR : null,
                      }}
                    >
                      <FontAwesomeIcon
                        disabled={isUpdating || isToDelete}
                        icon={EnablePrescreenForm ? faCheckSquare : faSquare}
                        style={{
                          marginRight: 10,
                          cursor: 'pointer',
                          color: EnablePrescreenForm ? PRESCREEN_TYPE_COLOR : null,
                        }}
                        onClick={() => {
                          changeValue(groupIndex, questionIndex, 'prescreen');
                        }}
                      />
                      Prescreen
                    </div>
                    <div style={{ color: EnablePrescreenForm ? PRESCREEN_TYPE_COLOR : null }}>
                      {resolvedWeightQuestionType === 'scale' ? prePercentage : '-'}
                    </div>
                  </div>
                ) : null}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      color: EnableEvaluationForm ? EVALUATION_TYPE_COLOR : null,
                    }}
                  >
                    <FontAwesomeIcon
                      disabled={isUpdating || isToDelete}
                      icon={EnableEvaluationForm ? faCheckSquare : faSquare}
                      style={{
                        marginRight: 10,
                        cursor: 'pointer',
                        color: EnableEvaluationForm ? EVALUATION_TYPE_COLOR : null,
                      }}
                      onClick={() => {
                        changeValue(groupIndex, questionIndex, 'evaluation');
                      }}
                    />
                    Evaluation
                  </div>
                  <div style={{ color: EnableEvaluationForm ? EVALUATION_TYPE_COLOR : null }}>
                    {resolvedWeightQuestionType === 'scale' ? evalPercentage : '-'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <tr
      id={`id_${pk_EvaluationQuestion || uuid}`}
      key={`id_${pk_EvaluationQuestion || uuid}`}
      name={`id_${pk_EvaluationQuestion || uuid}`}
      style={{ backgroundColor: backgroundColor }}
      onClick={() => {
        setSelectedQuestionId(pk_EvaluationQuestion || uuid);
      }}
    >
      <td>
        <Button
          disabled={isUpdating}
          color={(pk_EvaluationQuestion && !isToDelete) || !pk_EvaluationQuestion ? 'danger' : 'secondary'}
          onClick={() => {
            if (!pk_EvaluationQuestion) {
              Swal.fire({
                title: 'Warning!',
                text: `Are you sure you want to delete this question? This cannot be undone.`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'red',
                confirmButtonText: `Delete`,
              }).then((result) => {
                if (result.value) {
                  deleteQuestion();
                }
              });
            } else {
              deleteQuestion();
            }
          }}
        >
          <FontAwesomeIcon icon={pk_EvaluationQuestion && isToDelete ? faRedoAlt : faTrash} />
        </Button>
      </td>
      <td>
        {isToDelete ? (
          <div style={{ fontWeight: 'bold', color: 'white' }}>DELETE</div>
        ) : (
          <Input
            disabled={isUpdating}
            type="select"
            id={`sort_${pk_EvaluationQuestion}`}
            key={`sort_${pk_EvaluationQuestion}`}
            name={`sort_${pk_EvaluationQuestion}`}
            value={EvaluationQuestionSortOrder}
            onChange={(e) => {
              changeSortOrder(groupIndex, questionIndex, parseInt(e.target.value));
              // changeValue(groupIndex, questionIndex, 'EvaluationQuestionSortOrder', e.target.value, pk_QuestionGroup);
            }}
          >
            {questions && questions[groupIndex].questions ? (
              questions[groupIndex].questions.map((item, count) => (
                <option key={item.pk_EvaluationQuestion} value={count + 1}>
                  {count + 1}
                </option>
              ))
            ) : (
              <option value={null} disabled selected>
                No Sort Order
              </option>
            )}
          </Input>
        )}
      </td>
      <td>
        <div>{isRequired || EnableRequired ? <h6 style={{ color: '#FF0000', fontWeight: 700 }}>*</h6> : null}</div>
      </td>
      <td>
        <div style={style.simpleRow}>
          <div style={{ ...style.simpleColumn, width: 20, fontWeight: 'bold', color: 'red' }}>
            {EnableRequired ? '*' : <br />}
          </div>
          <div style={style.simpleColumn}>
            <Input
              disabled={isUpdating || isToDelete}
              type="textarea"
              style={{ width: '100%' }}
              rows="2"
              id={`name_${pk_EvaluationQuestion}_${JSON.stringify(question)}`}
              key={`name_${pk_EvaluationQuestion}`}
              defaultValue={`${QuestionText}`}
              onChange={(e) => {
                const newValue = e.target.value;
                if (typeTimeout) {
                  if (lastTypeField !== 'QuestionText') {
                    lastTypeField = 'QuestionText';
                    if (typeTimeout.trigger) {
                      typeTimeout.trigger();
                    }
                  }
                  clearTimeout(typeTimeout);
                }
                typeTimeout = setTimeout(() => {
                  changeValue(groupIndex, questionIndex, 'QuestionText', newValue, pk_QuestionGroup);
                  lastTypeField = null;
                }, 300);

                // changeValue(groupIndex, questionIndex, 'QuestionText', e.target.value, pk_QuestionGroup);
              }}
            />
          </div>
        </div>
      </td>
      <td>
        {resolvedWeightQuestionType === 'scale' /*&& Math.random() * 100 > 50*/ ? (
          <Button
            disabled={isUpdating || isToDelete}
            color={question.EnableCustomScale ? 'success' : 'warning'}
            onClick={(e) => {
              e.preventDefault();
              labelClick({ ...question, questionIndex, groupIndex });
            }}
          >
            <FontAwesomeIcon icon={faEllipsisH} />
          </Button>
        ) : null}
      </td>
      <td>
        <Input
          disabled={isUpdating || isToDelete}
          type="select"
          name="weightCategorySelect"
          style={{ width: '100%' }}
          onChange={onWeightChange}
          value={pk_EvaluationQuestionWeight}
        >
          {questionWeights.map((item) => {
            return (
              <option
                selected={item.pk_EvaluationQuestionWeight === pk_EvaluationQuestionWeight}
                value={item.pk_EvaluationQuestionWeight}
              >
                {item.CategoryName}
              </option>
            );
          })}
        </Input>
      </td>
      <td>
        <Button
          disabled={isUpdating || isToDelete}
          type="button"
          id={`button_${pk_EvaluationQuestion}_focusButton`}
          color="secondary"
          size="sm"
          style={{ width: 220 }}
          onClick={() => {}}
        >
          <div style={style.spacedBetweenRow}>
            <div style={style.ellipsis}> {getFocusNames()}</div>
            <div style={{ marginRight: 10 }}>({selectedFocuses.length})</div>
            <FontAwesomeIcon icon={faChevronDown} />
          </div>
        </Button>
        <UncontrolledTooltip target={`button_${pk_EvaluationQuestion}_focusButton`}>
          {getFocusNames()}
        </UncontrolledTooltip>
        {renderFocusPopover()}
      </td>

      <td>
        {AllowPrescreen ? (
          <div
            style={{
              ...style.simpleRow,
              alignItems: 'center',
              justifyContent: 'space-between',
              color: EnablePrescreenForm ? PRESCREEN_TYPE_COLOR : null,
            }}
          >
            <FontAwesomeIcon
              disabled={isUpdating || isToDelete}
              icon={EnablePrescreenForm ? faCheckSquare : faSquare}
              style={{
                marginRight: 10,
                cursor: 'pointer',
                color: EnablePrescreenForm ? PRESCREEN_TYPE_COLOR : null,
              }}
              onClick={() => {
                changeValue(groupIndex, questionIndex, 'prescreen');
              }}
            />
            Prescreen
          </div>
        ) : null}
        <div
          style={{
            ...style.simpleRow,
            alignItems: 'center',
            justifyContent: 'space-between',
            color: EnableEvaluationForm ? EVALUATION_TYPE_COLOR : null,
          }}
        >
          <FontAwesomeIcon
            disabled={isUpdating || isToDelete}
            icon={EnableEvaluationForm ? faCheckSquare : faSquare}
            style={{
              marginRight: 10,
              cursor: 'pointer',
              color: EnableEvaluationForm ? EVALUATION_TYPE_COLOR : null,
            }}
            onClick={() => {
              changeValue(groupIndex, questionIndex, 'evaluation');
            }}
          />
          Evaluation
        </div>
      </td>

      <td>
        {resolvedWeightQuestionType === 'scale' ? (
          <>
            {AllowPrescreen ? (
              <div style={{ ...style.simpleRow }}>
                <div style={{ ...style.simpleColumn, color: EnablePrescreenForm ? PRESCREEN_TYPE_COLOR : null }}>
                  {prePercentage}
                </div>
              </div>
            ) : null}

            <div style={style.simpleRow}>
              <div style={{ ...style.simpleColumn, color: EnableEvaluationForm ? EVALUATION_TYPE_COLOR : null }}>
                {evalPercentage}
              </div>
            </div>
          </>
        ) : (
          <>
            {AllowPrescreen ? (
              <div style={style.simpleRow}>
                <div style={{ ...style.simpleColumn, color: EnablePrescreenForm ? PRESCREEN_TYPE_COLOR : null }}>-</div>
              </div>
            ) : null}

            <div style={style.simpleRow}>
              <div style={{ ...style.simpleColumn, color: EnableEvaluationForm ? EVALUATION_TYPE_COLOR : null }}>-</div>
            </div>
          </>
        )}
      </td>
    </tr>
  );
};

export default EvaluationQuestion;

// no templates for questions except for the default!

// no value - 1 through however many likert or dreyfus questions

// yes no toggle in elipses

// custom or default button

// yes/no, custom, default
